<script>
    import {clickOutside} from "../../lib/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    import {copyObject, setFocusTo, upCaseStr} from "../../lib/lib";

    export let groups = null;
    export let selected = [];

    let list = null;
    let showDropdown = false;
    let term = '';
    let listIndex = -1;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const toggleDropdown = () => {
        if (!showDropdown) {
            list = copyObject(groups);
            listIndex = -1;
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
            setFocusTo("groupTerm");

            // set dropdown width so it wont change in search results
            setTimeout(function () {
                let box = document.getElementById('groupsDropdown');
                if (box) {
                    box.style.width = box.offsetWidth + "px";
                }
            }, 100);
        } else {
            closeDropdown();
        }
    }

    const closeDropdown = () => {
        showDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
        list = null;
        term = '';
    }

    const onSelect = (item) => {
        closeDropdown();
        dispatch("select", item);
    }

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (listIndex > -1) {
                onSelect(list[listIndex]);
            }
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            listIndex--;
            if (listIndex < 0) {
                listIndex = list.length - 1;
            }
        } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            listIndex++;
            if (listIndex > list.length - 1) {
                listIndex = 0;
            }
        } else {
            let search = upCaseStr(term);
            list = groups.filter(x => upCaseStr(x.name).includes(search));
            listIndex = -1;
        }
    }
</script>

<div class="dropdown-container groups-container ms-1">
    <button class="btn btn-default" title="ομάδες αναλύσεων" on:click={ toggleDropdown }>
        <AppIcon icon="vials"/>
    </button>
    {#if showDropdown}
        <div class="dropdown right" id="groupsDropdown" use:clickOutside on:click_outside="{ closeDropdown }">
            <div class="p-1">
                <input type="text" class="form-control form-control-sm" id="groupTerm" bind:value="{ term }"
                       on:keydown={ onKeyDown } placeholder="όνομα ομάδας">
            </div>
            <div class="wrapper">
                <ul>
                    {#each list as item, index}
                        <li class="dropdown-item pointer" class:selected={ index == listIndex }
                            on:click={ () => onSelect(item) }>
                            { item.name }
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    {/if}
</div>
<style>
    .groups-container {
        width: max-content;
    }

    .groups-container .dropdown {
        min-width: 160px;
        width: max-content;

    }

    .groups-container .dropdown .wrapper {
        max-height: 250px;
        overflow-y: auto;
    }

    .groups-container .dropdown ul {
        padding: 0;
    }

    .groups-container .dropdown .dropdown-item {
        color: #333;
        padding: 5px 10px;
    }
</style>